import Chart from "react-apexcharts";
import { colors } from "../../GlobalDashboardPage";

export interface IVerticalChartProps {
  data: number[];
  categories: string[];
  seriesName: string;
}

const VerticalBarChart = ({ data, categories, seriesName }: IVerticalChartProps) => {
  const options: ApexCharts.ApexOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "80%",
        borderRadius: 6,
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -25,
      style: {
        colors: ["#000"],
        fontSize: '14px',
        fontWeight: 600
      }
    },
    xaxis: {
      categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        gradientToColors: [colors.purple],
        stops: [0, 100],
      },
    },
    colors: [colors.lightPurple],
    legend: {
      show: false,
    },
    tooltip: {
      enabled: true,
    }
  };

  const series = [
    {
      name: seriesName.charAt(0).toUpperCase() + seriesName.slice(1),
      data,
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={"90%"}
    />
  );
};

export default VerticalBarChart;
